import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const commonCss = css({
  // position: 'absolute',
  // height: 'fit-content',
  // // top: 295,
  // right: '16%',
  // zIndex: 1,
  // transition: 'all 300ms linear',

  [MediaQueries.sm]: {
    right: '0',
    position: 'relative',
    padding: '0px',
    bottom: '0',
  },
  [MediaQueries.md]: {
    right: '48px',
    padding: '0px',
  },

  bottom: '-20%',

  '.learnmore': {
    color: '#E52500',
    textDecoration: 'none',
    fontSize: '18px',

    'span:first-child': {
      borderBottom: '#FAD3CC solid 1px',
      paddingBottom: '8px',
      marginRight: '16px',
    },

    i: {
      position: 'relative',
      top: '2px',
    },
  },

  '.shadow_bg': {
    // height: '80px',
    // position: 'absolute',
    // width: '100%',
    // bottom: '0',
    // zIndex: 9999,
    [MediaQueries.lg]: {
      right: '40.3125px',
      width: '376px',
    },
    [MediaQueries.md]: {
      display: 'none',
    },
    [MediaQueries.sm]: {
      display: 'none',
    },
  },
  '.scroll_bannerpart': {
    position: 'relative',
    padding: '40px 40px 40px 40px',
    background: '#FFFFFF',
    width: '416px',
    boxShadow: '0px 24px 128px rgba(57, 57, 57, 0.2)',
    [MediaQueries.sm]: {
      width: '100%',
      padding: '24px 24px 24px 24px',
      marginTop: '0px',
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
    },
    [MediaQueries.md]: {
      width: '344px',
      padding: '24px 24px 24px 24px',
    },
    [MediaQueries.lg]: {
      width: '376px',
      padding: '24px 24px 24px 24px',
    },

    h2: {
      fontSize: '32px',
      lineHeight: '32px',
      fontWeight: '500',
      marginBottom: '24px',

      [MediaQueries.sm]: {
        fontSize: '28px',
      },
      [MediaQueries.lg]: {
        fontSize: '28px',
      },
      [MediaQueries.md]: {
        fontSize: '28px',
      },
    },

    ul: {
      // maxHeight: '224px',
      overflow: 'auto',

      li: {
        fontSize: '16px',
        lineHeight: '24px',
        marginBottom: '24px',
        display: 'flex',

        '.img_icon': { display: 'flex' },

        img: {
          marginRight: '16px',
        },
      },

      '::-webkit-scrollbar': { width: '10px' },
      '::-webkit-scrollbar-track': { background: '#fff' },
      '::-webkit-scrollbar-thumb': { background: '#fff' },
      '::-webkit-scrollbar-thumb:hover': { background: '#fff' },
    },
  },
});

export const DarkModeCss = css({});

export const LightModeCss = css({
  '.scroll_bannerpart': {
    [MediaQueries.md]: {
      boxShadow: 'none',
    },
  },
});
